import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { userData } from "../data/userData";
import {
  aboutMeRoute,
  contactRoute,
  homeRoute,
  macrosRoute,
  mobileRoute,
  otherProjectsRoute,
  productDesignsRoute,
  webRoute,
} from "../constants/routeConstants";

export const MobileMenu = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const activeClass =
    "py-5 text-right hover:text-red-500 text-black font-medium ";
  // const deactClass = "py-5 text-red-500";

  return (
    <div className="sm:hidden flex flex-row justify-between">
      <NavLink to="/">
        <div className="inline-flex flex-col text-white m-6 text-right hover:text-gray-300 cursor-pointer flex-1">
          <span className="text-2xl ">{"Emre Sönmez"}</span>
          <span className="text-sm italic">{userData.title}</span>
        </div>
      </NavLink>
      {showMobileMenu && (
        <div className="absolute right-0 top-16 bg-gray-200 rounded-xl p-3 z-10 transition-transform border-2 border-gray-300">
          <nav>
            <div className="flex flex-col flex-auto p-3 h-full justify-around gap-1">
              <NavLink
                to={homeRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                Home
              </NavLink>
              <hr className="border border-gray-300" />
              <NavLink
                to={aboutMeRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                About Me
              </NavLink>
              <hr className="border border-gray-300" />
              <NavLink
                to={macrosRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                {`Macros & GUIs`}
              </NavLink>
              <hr className="border border-gray-300" />
              <NavLink
                to={mobileRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                {`Mobile Projects`}
              </NavLink>
              <hr className="border border-gray-300" />
              <NavLink
                to={webRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                {`Web Projects`}
              </NavLink>
              <hr className="border border-gray-300" />
              <NavLink
                to={productDesignsRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                {`Product & Mechanical Design`}
              </NavLink>
              <hr className="border border-gray-300" />
              <NavLink
                to={otherProjectsRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                Other Projects
              </NavLink>
              <hr className="border border-gray-300" />
              <NavLink
                to={contactRoute}
                onClick={() => setShowMobileMenu(false)}
                className={activeClass}
              >
                Contact
              </NavLink>
            </div>
          </nav>
        </div>
      )}
      <div className="text-right p-3">
        <button
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          className="py-2 px-3 bg-gray-300 text-gray-700 rounded-md"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
    </div>
  );
};
